import * as tslib_1 from "tslib";
import axios from 'axios';
/**
 * Members Api - client for groups site members api
 * https://bo.wix.com/wix-docs/rest/business-apis#social-groups.social-group-membership
 *
 */
var MembersApi = /** @class */ (function () {
    /**
     * @param {string} token - jwt for site instance
     * (see [more](https://github.com/wix-private/platformization-guidelines/blob/master/guides/instance.md#instance))
     * @param {string} apiUrl
     */
    function MembersApi(token, apiUrl) {
        this.token = token;
        this.axios = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: token,
            },
        });
    }
    MembersApi.prototype.listGroupMembers = function (groupId) {
        return this.axios.get(this.getUrl(groupId));
    };
    MembersApi.prototype.getUrl = function (groupId) {
        return "/v1/groups/" + groupId + "/members";
    };
    MembersApi.prototype.listAllMembers = function (groupId) {
        return this.axios.get(this.getUrl(groupId) + "/all");
    };
    // TODO: must be api call for /filter - waiting for backend https://jira.wixpress.com/browse/GROUP-436
    MembersApi.prototype.filterMembers = function (groupId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, members;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listAllMembers(groupId)];
                    case 1:
                        response = _a.sent();
                        members = (response.data.members || []).filter(function (member) { return member.name && member.name.nick.includes(query); });
                        members.length = Math.min(members.length, 5);
                        response.data.members = members;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    MembersApi.prototype.joinGroup = function (groupId) {
        return this.axios.post(this.getUrl(groupId) + "/me");
    };
    MembersApi.prototype.withdrawRequestToJoin = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/request");
    };
    MembersApi.prototype.submitRequestToJoin = function (groupId) {
        return this.axios.post(this.getUrl(groupId) + "/request");
    };
    MembersApi.prototype.leaveGroup = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/me");
    };
    MembersApi.prototype.getGroupMember = function (groupId, siteMemberId) {
        return this.axios.post(this.getUrl(groupId) + "/member/" + siteMemberId);
    };
    MembersApi.prototype.addToGroup = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/add", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.getCurrentMember = function () {
        //TODO: maybe use group api?
        return axios.get('https://users.wix.com/_api/wix-sm-webapp/v1/members/current', {
            headers: {
                Authorization: this.token,
            },
        });
    };
    return MembersApi;
}());
export { MembersApi };
//# sourceMappingURL=MembersApi.js.map